import _taggedTemplateLiteral from "/home/bamboo/bamboo-agent-home/xml-data/build-dir/UDFGE-ESHOP4-JOB1/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral.js";
var _templateObject;
import { jsxs, jsx } from 'react/jsx-runtime';
import { Spacing, Row, Column, Text, Button } from '@dls/web';
import img from '../../assets/images/illustration-error.png.js';
import styled from 'styled-components';
const ErrorBlock = props => {
  const {
    imageSrc = img,
    title,
    description,
    buttonOption,
    bottomSpace = 3,
    topSpace = 0
  } = props;
  const {
    text = "Back to home",
    onClick
  } = buttonOption || {};
  return /* @__PURE__ */jsxs(Spacing, {
    bottom: bottomSpace,
    top: topSpace,
    children: [/* @__PURE__ */jsx(Row, {
      center: "xs",
      children: /* @__PURE__ */jsxs(Column, {
        xs: 12,
        md: 10,
        children: [/* @__PURE__ */jsx(ErrorBlockImageContainer, {
          children: /* @__PURE__ */jsx("img", {
            src: imageSrc,
            alt: "Error",
            className: "w-100 h-auto"
          })
        }), /* @__PURE__ */jsx(Text, {
          tag: "div",
          type: "pageTitle",
          className: "mt-6",
          children: title
        }), /* @__PURE__ */jsx(Text, {
          tag: "div",
          type: "body",
          className: "mt-4",
          children: description
        })]
      })
    }), buttonOption && /* @__PURE__ */jsx(Row, {
      center: "xs",
      children: /* @__PURE__ */jsx(Column, {
        xs: 12,
        md: 4,
        children: /* @__PURE__ */jsx(Spacing, {
          top: 2,
          children: /* @__PURE__ */jsx(Button, {
            secondary: true,
            fullWidth: true,
            onClick,
            children: text
          })
        })
      })
    })]
  });
};
const ErrorBlockImageContainer = styled.div(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  max-width: 540px;\n  margin: auto;\n"])));
export { ErrorBlock as default };